// Project data with detailed content for each project
export const PROJECTS_DATA = [
    {
        id: "ai-quota",
        title: "Z.ai Quota Tracker",
        category: "Developer Dashboard",
        description:
            "Mobile-first dashboard for Z.ai (GLM) usage. Shows the same numbers as z.ai/manage-apikey/subscription, plus a playground for testing prompts. Runs as a Telegram Mini App or a plain web app.",
        images: [require("@public/screenshot/ai-qouta-screenshot.png").default],
        details: {
            overview:
                "Single Next.js app with no separate backend. One Route Handler proxies Z.ai's undocumented monitor endpoints to dodge browser CORS, and all data lives in localStorage. Overview and Usage tabs aggregate across every key you add; the Playground records its own per-call cost and tokens into a local event log so pay-as-you-go keys still get tracked against a budget.",
            features: [
                "5-hour quota with reset countdown and plan tier (lite, pro, max).",
                "Search, Reader, and Zread monthly quota for Coding Plan keys.",
                "Tokens and requests over the last 7 or 30 days, with a line chart and totals.",
                "Per-model donut and ranked list for Today, 7d, or 30d.",
                "Playground with streamed chat completions, per-call cost, and a local usage log.",
                "In-app threshold alerts at 50, 75, 90, and 95 percent.",
                "Multi-key support with aggregation across keys and a Playground key switcher.",
                "Runs as a Telegram Mini App with a dev mock fallback outside Telegram.",
            ],
            technologies: [
                "Next.js 16 (App Router)",
                "React 19",
                "TypeScript 5",
                "Tailwind CSS v4",
                "shadcn/ui",
                "vaul",
                "TanStack Query",
                "Zustand",
                "Recharts",
                "@hugeicons/react",
                "@telegram-apps/sdk-react",
            ],
            githubUrl: "https://github.com/phalla-doll/ai-quota",
            liveUrl: "https://t.me/zi_ai_quota_bot",
        },
    },
    {
        id: "xml-visual-graph",
        title: "XML Visual Graph",
        category: "Developer Tool",
        description:
            "Turns EDMX or OData $metadata into an interactive entity-relationship graph in the browser. Inspect entities, navigate relationships, and export as Mermaid or JSON.",
        images: [require("@public/screenshot/xml-visual-graph.png").default],
        details: {
            overview:
                "Paste a schema document or drop in .xml/.edmx files and the app parses, lays out, and renders the entities with React Flow and Dagre. Multiple schemas merge into one graph. Click an entity to see its properties, primary keys, and incoming and outgoing relationships. Parsing, layout, and rendering all run in the browser; the only server route is a thin proxy to NVIDIA's gpt-oss-120b for AI entity summaries.",
            features: [
                "Paste EDMX/OData $metadata or upload .xml and .edmx files.",
                "Merge entities across multiple schemas into one graph.",
                "Auto-layout with Dagre, then drag nodes freely.",
                "Crow's-foot edges with navigation property labels.",
                "Inspector shows properties, primary keys, types, and relationships.",
                "AI summary per entity, scoped to its neighbors.",
                "Export as a Mermaid ER diagram or as JSON.",
                "LR or TB layout, dark and light themes.",
                "Workspace state persists in localStorage.",
            ],
            technologies: [
                "Next.js 16 (App Router)",
                "React 19",
                "TypeScript",
                "Tailwind CSS v4",
                "shadcn/ui",
                "@xyflow/react",
                "Dagre",
                "fast-xml-parser",
                "Zustand",
                "NVIDIA AI (gpt-oss-120b)",
            ],
            githubUrl: "https://github.com/phalla-doll/visual-graph",
            liveUrl: "https://xml.manthaa.dev",
        },
    },
    {
        id: "project-sonam",
        title: "Project Sonam",
        category: "Ebook Reader",
        description:
            "Read and download from 70,000+ free public domain ebooks. Includes an AI assistant for book-scoped questions.",
        images: [require("@public/screenshot/project-sonam.png").default],
        details: {
            overview:
                "Built on the Gutendex API for the catalog and NVIDIA's LLM for the assistant. The reader detects chapters and shows a TOC minimap, search filters by topic and language, and you can highlight a passage to ask a question scoped to that text. Server components and ISR caching keep the lists fast.",
            features: [
                "Infinite scroll feed with duplicate filtering and caching.",
                "Browse 20 curated topics: Fiction, Sci-Fi, Fantasy, Mystery, and more.",
                "Search by query, topic, and language.",
                "In-app text reader with chapter detection and a TOC minimap.",
                "Streaming AI assistant for book-scoped Q&A, powered by NVIDIA.",
                "Highlight a passage in the reader to ask a question about it.",
                "Download as HTML, EPUB, Kindle, plain text, or ZIP.",
                "Dark and light themes (toggle with D).",
                "ISR caching: lists revalidate hourly, details daily.",
            ],
            technologies: [
                "Next.js 16 (App Router)",
                "React 19",
                "TypeScript 5.9",
                "Tailwind CSS 4",
                "shadcn/ui + Radix UI",
                "NVIDIA AI (OpenAI SDK)",
                "Hugeicons",
                "Gutendex API",
            ],
            githubUrl: "",
            liveUrl: "https://project-sonam.manthaa.workers.dev/",
        },
    },
    {
        id: "khmer-segment",
        title: "Khmer Segment",
        category: "Open-Source Library",
        description:
            "Zero-dependency Khmer text library for JavaScript and TypeScript. Handles segmentation, normalization, and cluster splitting in any framework.",
        images: [require("@public/screenshot/khmer-segment.png").default],
        details: {
            overview:
                "Ships four segmentation algorithms (FMM, BMM, BiMM, and Viterbi frequency-weighted DP) over a 101,107-word trie dictionary. Includes React hooks, Angular adapters, and editor-friendly utilities for caret and cluster handling. Tree-shakeable, ESM and CJS, with TypeScript declarations.",
            features: [
                "Four segmentation algorithms: FMM, BMM, BiMM, and Viterbi (frequency-weighted DP).",
                "101,107-word trie dictionary with O(k) prefix lookup.",
                "Grapheme cluster splitting and Unicode normalization.",
                "React hooks (useKhmerSegments) and Angular adapters (KhmerSegmentService).",
                "Typing utilities: WPM, CPM, and accuracy with cluster-aware comparison.",
                "Zero runtime dependencies. Tree-shakeable. Ships ESM, CJS, and types.",
                "Interactive playground with live demo, strategy selector, and dictionary editing.",
            ],
            technologies: [
                "TypeScript 5.x",
                "tsup (ESM + CJS + declarations)",
                "Vitest",
                "Vite (playground)",
                "Tailwind CSS 4",
                "GitHub Actions CI",
            ],
            githubUrl: "https://github.com/phalla-doll/khmer-segment-js",
            liveUrl: "https://www.npmjs.com/package/khmer-segment",
        },
    },
    {
        id: "soro",
        title: "Soro",
        category: "Ambient Sound Mixer",
        description:
            "Ambient sound mixer for focus and sleep. Layer nature sounds, white noise, urban ambiance, and binaural beats.",
        images: [require("@public/screenshot/soro-og-image-main.png").default],
        details: {
            overview:
                "Layer sounds across nine categories into a single mix, each with its own level. The whole interface is built around long listening sessions: minimal chrome, calm motion, dark by default.",
            features: [
                "Layer multiple sounds, each with its own level.",
                "Nine categories: Nature, Rain, Places, Animals, Binaural, Noise, Things, Transport, Urban.",
                "Campfire, waves, rain variants, cafes, libraries, binaural beats, pink/white/brown noise, and more.",
                "Built for long focus and sleep sessions.",
                "Distraction-free UI tuned for long sessions.",
            ],
            technologies: [
                "Next.js 16",
                "React 19",
                "TypeScript",
                "Tailwind CSS 4",
                "Motion",
                "Hugeicons",
                "Web Audio API",
            ],
            githubUrl: "https://github.com/phalla-doll/grid-mix",
            liveUrl: "https://soro.manthaa.dev/",
        },
    },
    {
        id: "ascii-studio",
        title: "ASCII Studio",
        category: "Creative Tool",
        description:
            "Converts images into ASCII art in the browser. Tune resolution and character density, then export as text or PNG.",
        images: [require("@public/screenshot/ascii-og-image-main.png").default],
        details: {
            overview:
                "Drop in an image (upload, drag, or paste from clipboard). Adjust output width and pick a character density preset. Copy the ASCII, save as .txt, or export the rendered output as PNG.",
            features: [
                "Upload, drag and drop, or paste from clipboard.",
                "Tune character width to control output fidelity.",
                "Light, Balanced, and High density presets.",
                "Copy ASCII, download .txt, or export as PNG.",
                "Runs in the browser. No install.",
            ],
            technologies: [
                "Web Browser APIs",
                "Client-Side Image Processing",
                "ASCII Character Mapping",
                "Responsive UI",
            ],
            githubUrl: "",
            liveUrl: "https://ascii-art.manthaa.dev/",
        },
    },
    {
        id: "stage-timmer",
        title: "Stage Timer",
        category: "Utility Tool",
        description:
            "High-contrast stage timer for event operators. Multiple modes, color-coded signals, custom messages, and real-time sync via QR code.",
        images: [require("@public/screenshot/stage-timer.png").default],
        details: {
            overview:
                "Built for legibility from the back of the room and zero-latency sync between operator and stage. Three timer modes (countdown with overtime, countup, clock), color-coded signals, presetable messages, and display effects. Share the live display via QR or link.",
            features: [
                "Zero-latency sync over Convex.",
                "Countdown with overtime, countup, and clock modes.",
                "Color-coded signals: SPEED UP, WRAP UP, TIME'S UP.",
                "Custom messages with saveable presets.",
                "Flash, invert, and animate display effects.",
                "Share the display via QR code or one-click link.",
            ],
            technologies: [
                "Next.js 15 (App Router)",
                "React 19",
                "TypeScript",
                "Tailwind CSS v4",
                "Convex (Real-Time Backend & Database)",
                "react-qr-code",
                "motion/react",
            ],
            githubUrl: "https://github.com/phalla-doll/stage-timmer",
            liveUrl: "https://stage.manthaa.dev",
        },
    },
    {
        id: "json-forge",
        title: "JSON Forge",
        category: "Developer Tool",
        description:
            "JSON editor for large files. Monaco editing, a navigable graph view, and validation that stays responsive past 10k lines.",
        images: [
            require("@public/screenshot/json-forge-screenshot.webp").default,
        ],
        details: {
            overview:
                "Aimed at payloads that stall typical web formatters. Debounced parsing and a virtualized graph view keep the UI responsive past 10k lines. Lazy expansion handles huge arrays and objects without rendering everything at once.",
            features: [
                "Monaco editor with highlighting, folding, and indentation.",
                "Real-time validation with clear error feedback.",
                "Prettify, minify, and indent (2 or 4 spaces, or tabs).",
                "Debounced parsing, virtualized graph, and lazy expansion for huge arrays and objects.",
                "Graph view with search, pan/zoom, and tooltips showing full JSON paths.",
                "Drag-and-drop import, export, status stats, dark and light themes.",
            ],
            technologies: [
                "Monaco Editor",
                "React",
                "TypeScript",
                "Tailwind CSS",
            ],
            githubUrl: "https://github.com/phalla-doll/json-forge",
            liveUrl: "https://json.manthaa.dev/",
        },
    },
    {
        id: "avocado-chat",
        title: "Avocado Chat",
        category: "AI Chat App",
        description:
            "Client-side AI chat with model and personality switching, streaming responses, and session persistence. No database.",
        images: [require("@public/screenshot/avocado-chat.png").default],
        details: {
            overview:
                "Five AI models via NVIDIA's API and seven switchable personalities, each with its own system prompt. Streaming responses include collapsible chain-of-thought. Sessions persist in localStorage and can be shared via URL. Installable as a PWA, with 17 message templates across four categories.",
            features: [
                "Five models: GPT OSS 120B, Gemma 4 31B, DeepSeek V4 Flash, Minimax M2.7, Nemotron 120B.",
                "Seven personalities: Helpful Assistant, Critical Thinker, Formal Professional, and more.",
                "Streaming responses with collapsible chain-of-thought.",
                "17 message templates across Writing, Professional, Social, and Utility.",
                "Sessions persist in localStorage and share via URL.",
                "Installable PWA with offline detection and a service worker.",
                "Dark and light themes, slash commands, file attachments, and QR sharing.",
            ],
            technologies: [
                "Next.js 16 (App Router)",
                "React 19",
                "TypeScript 5.9",
                "Tailwind CSS 4",
                "Vercel AI SDK v6",
                "NVIDIA AI (OpenAI-Compatible)",
                "shadcn/ui + Radix UI",
                "Hugeicons",
            ],
            githubUrl: "https://github.com/phalla-doll/message-me",
            liveUrl: "https://chat.manthaa.dev/",
        },
    },
    {
        id: "vsa",
        title: "Story Assistant",
        category: "AI Tool",
        description:
            "Paste a transcript and get visual direction back, scene by scene. Mood tags, transcript excerpts, keywords, and asset suggestions per scene.",
        images: [require("@public/screenshot/vsa-screenshot.jpeg").default],
        details: {
            overview:
                "Supports Google Gemini and OpenRouter, with each one falling back to the other if a key is missing. Optional stock-style image previews. Single-page Next.js app with a transcript column (word count, read time, generate) and a results column for staggered scene cards. Keys and provider choice live in localStorage.",
            features: [
                "Scenes generated from pasted transcripts, each with a mood tag.",
                "Per-scene visual direction and transcript excerpts.",
                "Keywords, optional image previews, and links to stock photos.",
                "Gemini or OpenRouter, with automatic fallback if a key is missing.",
                "Transcript stats: word count, characters, read time, size.",
                "Dark UI with motion, plus a settings modal for keys and provider.",
                "API keys and provider saved in localStorage.",
            ],
            technologies: [
                "Next.js (App Router)",
                "React",
                "TypeScript",
                "Tailwind CSS",
                "Framer Motion",
                "Lucide React",
                "@google/genai",
                "OpenRouter API",
            ],
            githubUrl: "https://github.com/phalla-doll/vsa",
            liveUrl: "https://vsa.manthaa.dev/",
        },
    },
    {
        id: "neon-play",
        title: "Neon Play",
        category: "Gaming Platform",
        description:
            "Browser-based platform with 250+ embedded games across 14 categories. Search, history, favorites, and social sharing.",
        images: [require("@public/screenshot/neon-play.jpeg").default],
        details: {
            overview:
                "A YouTube-style game embedding site with a neon-on-dark aesthetic. Pulls 250+ titles from OnlineGames.io and adds a player with fullscreen, search by title or category, history of up to 20 recent games, and bookmarks for up to 20 favorites.",
            features: [
                "250+ curated browser games across genres.",
                "14 categories: Action, Racing, Arcade, Puzzle, Casual, Sports, Shooting, Drift, Simulator, Adventure, Strategy, 2 Player, Girl.",
                "Search by title, category, or developer.",
                "Game pages with descriptions, view counts, and release dates.",
                "Game player with fullscreen support.",
                "Share to Twitter or Facebook, or copy link.",
                "Tracks up to 20 recently played games.",
                "Bookmark up to 20 favorites.",
                "Responsive across mobile, tablet, and desktop.",
                "Google Analytics 4 tracking.",
            ],
            technologies: [
                "Next.js 15 (App Router)",
                "React 19",
                "TypeScript",
                "Tailwind CSS v4",
                "HugeIcon icons",
                "Motion (animations)",
                "Google Analytics 4",
                "localStorage (game history, saved games)",
            ],
            githubUrl: "https://github.com/phalla-doll/neon-play",
            liveUrl: "https://neongame.online",
        },
    },
    {
        id: "168-hours",
        title: "168 Hours",
        category: "Productivity",
        description:
            "Map how you spend all 168 hours in a week. Compare reality to your ideal, and see the gaps translated into yearly hours.",
        images: [require("@public/screenshot/168-screenshot.png").default],
        details: {
            overview:
                "Paint categories onto a Monday-through-Sunday grid at one-hour resolution, for both your real week and an ideal one. The dashboard compares the two with pie and bar charts, a balance score, and insights that translate weekly gaps into annual hours and approximate days. State persists in the browser. Start from a sample week or build your own categories.",
            features: [
                "Two 7×24 grids (current and ideal weeks) with category painting and multi-cell updates.",
                "Dashboard with hours tracked, balance score, pie and bar charts, and per-category current vs ideal.",
                "Over- and under-allocated categories shown with their annual impact in hours and approximate days.",
                "Add, edit, and delete categories with colors. Defaults and sample presets included.",
                "Sample mode loads illustrative data; restore returns to your saved week.",
            ],
            technologies: [
                "Next.js 15 (App Router)",
                "React 19",
                "TypeScript",
                "Tailwind CSS 4",
                "Zustand (persist to localStorage)",
                "Recharts",
                "Motion",
            ],
            githubUrl: "https://github.com/phalla-doll/168-hours",
            liveUrl: "https://168.manthaa.dev",
        },
    },
    {
        id: "global-conflict-monitor",
        title: "Global Conflict",
        category: "Data Dashboard",
        description:
            "Dashboard for monitoring global conflicts and escalation events.",
        images: [
            require("@public/screenshot/global-conflict-monitor.png").default,
        ],
        details: {
            overview:
                "A structured data dashboard with conflict tracking and escalation event updates. Dark UI.",
            features: [
                "Structured display for conflict tracking.",
                "Real-time escalation events.",
                "Dark interface.",
            ],
            technologies: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
            githubUrl: "https://github.com/phalla-doll/global-conflict-monitor",
            liveUrl: "https://global-conflict-monitor-eight.vercel.app",
        },
    },
    {
        id: "sell-bot-website",
        title: "SellBot",
        category: "AI Sales Assistant",
        description:
            "Autonomous sales assistant for merchants. Automates replies, syncs inventory in real time, and grounds answers in a deterministic catalog.",
        images: [require("@public/screenshot/sale-bot-agent.png").default],
        details: {
            overview:
                "Marketing site for a sales bot product. The hero pairs a live code editor demo with typing animation; below, a Telegram chat simulation switches views automatically. Sections cover pricing tiers, an FAQ, a dashboard preview, and a multi-step deploy modal.",
            features: [
                "Interactive hero with a live code editor demo and typing animation.",
                "Telegram chat simulation that switches views automatically.",
                "Headline stats: 99.9% uptime, 24/7 ops, $50,000+ yearly savings, 0% hallucination rate.",
                "Ingest CSV or API feed into a deterministic knowledge graph.",
                "40+ languages: EN, KM, ES, FR, CN, JP, and more.",
                "Automated escalation routing for complex queries.",
                "Guardrails that keep conversations on topic.",
                "Vector index builds in under 60 seconds.",
                "Interactive dashboard preview.",
                "Three pricing tiers: CORE ($29), SCALAR ($79), ENTERPRISE (custom).",
                "FAQ accordion and customer testimonials.",
                "Multi-step deploy modal.",
            ],
            technologies: [
                "Next.js 16.1.6 (App Router)",
                "React 19.2.3",
                "Tailwind CSS v4",
                "Framer Motion",
                "Hugeicons React",
                "TypeScript (Strict Mode)",
                "Biome",
                "React Compiler",
            ],
            githubUrl: "https://github.com/phalla-doll/sell-bot-website",
            liveUrl: "https://sell-bot-website.vercel.app/",
        },
    },
    {
        id: "shadcn-luma",
        title: "Shadcn Luma",
        category: "UI Component Library",
        description:
            "Curated UI components built on shadcn/ui, Radix, and Tailwind CSS v4. Rounded geometry, soft elevation, breathable layouts. Inspired by macOS Tahoe.",
        images: [
            require("@public/screenshot/shadcn-luma-screenshot.png").default,
        ],
        details: {
            overview:
                "Ships 55+ components in components/ui/ and 35+ card examples showing how they compose. Pill buttons use a seven-step radius scale starting at 0.625rem. Dark mode uses soft opacity-based borders instead of hard lines. Colors are defined in oklch with a neutral palette and a purple accent.",
            features: [
                "55+ components in components/ui/.",
                "35+ interactive card examples for composition patterns.",
                "Pill buttons with a seven-step radius scale starting at 0.625rem.",
                "Opacity-based borders for dark mode depth without hard lines.",
                "Neutral oklch palette with a purple primary.",
                "Interactive map via MapLibre GL and Protomaps.",
                "System-aware dark mode via next-themes.",
                "Google Analytics 4 with custom event tracking.",
            ],
            technologies: [
                "Next.js 16 (Turbopack)",
                "React 19",
                "TypeScript 5.9",
                "Tailwind CSS v4",
                "Radix UI + Base UI",
                "Hugeicons",
                "MapLibre GL + Protomaps",
            ],
            githubUrl: "https://github.com/phalla-doll/shadcn-luma",
            liveUrl: "https://ui.manthaa.dev/",
        },
    },
    {
        id: "gold-pulse",
        title: "Gold Pulse",
        category: "Financial Dashboard",
        description:
            "Dark-mode dashboard for real-time Gold (XAU/USD) tracking. AI-generated sentiment and live news via Google Gemini.",
        images: [
            require("@public/screenshot/gold-pulse-screenshot.png").default,
        ],
        details: {
            overview:
                "Tracks XAU/USD with Recharts, with time ranges from 1D to 1Y and unit conversion across troy ounce, gram, and chi/tael. Volume sits alongside price. Gemini handles the market sentiment summary and a Google-Search-grounded news feed; OpenRouter is the fallback. A table of top national gold holdings recalculates against the live spot price.",
            features: [
                "Live XAU/USD price with interactive Recharts.",
                "Time ranges: 1D, 7D, 1M, 6M, 1Y.",
                "Toggle between troy ounce, gram, and chi/tael.",
                "Trading volume plotted alongside price.",
                "Top national gold holdings, with values tied to the live spot price.",
                "Sentiment and summaries via Google Gemini (Bullish, Bearish, or Neutral).",
                "Live news via Gemini with Google Search Grounding, or OpenRouter as fallback.",
                "Rounded percentages and highlighted key insights.",
            ],
            technologies: [
                "React 19",
                "TypeScript",
                "Tailwind CSS",
                "Recharts",
                "Google Gemini API (@google/genai)",
                "OpenRouter",
                "Twelve Data API",
            ],
            githubUrl: "",
            liveUrl: "https://gold-monitor.manthaa.dev/",
        },
    },
    {
        id: "meteo-cambodia",
        title: "Meteo Cambodia",
        category: "Forecast Dashboard",
        description:
            "Weather analytics dashboard for Cambodia. Air quality and exchange rates pulled from the Ministry of Economy and Finance API.",
        images: [require("@public/screenshot/meto-cambodia.png").default],
        details: {
            overview:
                "Dark UI with a neon lime accent (#bfff00), Space Grotesk and JetBrains Mono. Grid-based layout based on the Stitch design (National Weather Analytics Dashboard V1) at 1280px wide.",
            features: [
                "Real-time weather data for Cambodia.",
                "Air quality metrics.",
                "Live exchange rates.",
                "Data pulled from the Ministry of Economy and Finance API.",
                "Built on a Stitch design source.",
                "Dark UI with a neon lime accent.",
                "Desktop-focused layout at 1280px width.",
            ],
            technologies: [
                "Next.js",
                "TypeScript",
                "Tailwind CSS",
                "Stitch MCP",
            ],
            githubUrl: "https://github.com/phalla-doll/meteo-cambodia",
            liveUrl: "https://meteo-cambodia.vercel.app",
        },
    },
    {
        id: "dentify",
        title: "Dentify",
        category: "Healthcare System",
        description:
            "Dental clinic management system. Scheduling, treatment tracking, digital records, and billing. Supabase handles auth and storage.",
        images: [require("@public/screenshot/dentify-new.png").default],
        details: {
            overview:
                "A clinic management tool covering the day-to-day: patient bookings, treatment history, billing, and staff scheduling. Real-time reminders for appointments.",
            features: [
                "Patient scheduling and appointment management.",
                "Digital treatment records and history.",
                "Billing and payment processing.",
                "Staff and resource management.",
                "Real-time notifications and reminders.",
            ],
            technologies: [
                "Next.js",
                "Supabase",
                "TypeScript",
                "Tailwind CSS",
                "React Hook Form",
            ],
            githubUrl: "",
            liveUrl: "https://dental.manthaa.dev/",
        },
    },
    {
        id: "calendra-pro",
        title: "Calendra Pro",
        category: "Scheduling Platform",
        description:
            "Scheduling and booking platform. Businesses expose real-time availability through a single shareable link. Customers book without back-and-forth email or messages.",
        images: [require("@public/screenshot/calendra.webp").default],
        details: {
            overview:
                "Calendar sync, smart reminders, payment integration, and multi-tenant SaaS architecture. The whole product is built to remove the back-and-forth of scheduling between business and customer.",
            features: [
                "Real-time availability via a single shareable link.",
                "Instant booking without back-and-forth coordination.",
                "Calendar sync.",
                "Smart reminders and notifications.",
                "Payment integration.",
                "Multi-tenant SaaS architecture.",
            ],
            technologies: [
                "Next.js",
                "Tailwind CSS v4",
                "Shadcn UI",
                "Node.js",
                "Supabase",
                "WorkOS",
                "TypeScript",
            ],
            githubUrl: "",
            liveUrl: "https://calendra-pro.vercel.app/",
        },
    },
    {
        id: "cambodia-conflict-info",
        title: "Cambodia Conflict",
        category: "Conflict Monitor",
        description:
            "Live log tracking incidents along the Cambodia-Thailand border. Detailed chronological situation reports of military activity.",
        images: [
            require("@public/screenshot/cambodia-conflict-info.webp").default,
        ],
        details: {
            overview:
                "Documents events along the Cambodia-Thailand border: bombings, artillery shelling, drone reconnaissance, infiltration attempts, and explosions. Each entry lists date, time, location, and a brief description, focused on Banteay Meanchey, Preah Vihear, and Battambang provinces. Reads like a situation report: munition counts, units involved, and whether the area is civilian or military.",
            features: [
                "Live log of border incidents and military activity.",
                "Chronological situation reports with dates, times, and locations.",
                "Incident types include bombings, artillery, drone reconnaissance, infiltration attempts, and explosions.",
                "Coverage centered on Banteay Meanchey, Preah Vihear, and Battambang provinces.",
                "Specifics include munition counts and units involved.",
                "Civilian vs military classification per incident.",
                "Real-time updates on territorial incidents.",
            ],
            technologies: ["Next.js", "TypeScript", "Tailwind CSS"],
            githubUrl: "",
            liveUrl: "https://cambodiaconflict.info/",
        },
    },
    {
        id: "science-paper-analyzer",
        title: "Multimodal Research",
        category: "AI Research Tool",
        description:
            "Multimodal research assistant for academic papers (PDFs or pasted text). Powered by Google Gemini 2.5 Flash. Built for the Google DeepMind hackathon.",
        images: [
            require("@public/screenshot/science-paper-analyzer.webp").default,
        ],
        details: {
            overview:
                "Extracts structured data, surfaces methodology, and pulls out figures. Batch processing for multiple PDFs and contextual Q&A on each paper. UI is a dual-theme HUD with adaptive visualization (ASCII charts, logarithmic scaling). Export analysis as Markdown.",
            features: [
                "Upload PDFs or paste raw text.",
                "Batch upload multiple PDFs.",
                "Chat with each paper in context.",
                "Dual-theme HUD interface (light and dark).",
                "Pulls out executive summary, methodology, and figures.",
                "Adaptive ASCII charts with logarithmic scaling.",
                "Graceful recovery and detailed diagnostics on failures.",
                "Open Graph tags for sharing.",
                "Export analysis as Markdown.",
            ],
            technologies: [
                "Google Gemini 2.5 Flash",
                "Next.js",
                "TypeScript",
                "Tailwind CSS",
            ],
            githubUrl: "",
            liveUrl: "https://scientific-paper-analyzer.vercel.app/",
        },
    },
    {
        id: "real-time-earth-3d",
        title: "Real-Time Earth 3D",
        category: "3D Visualization",
        description:
            "3D Earth that rotates in real time, synced to UTC. Solar and sidereal modes, axial tilt at 23.4°, full Earth-Moon-Sun system.",
        images: [require("@public/screenshot/real-time-earth.jpeg").default],
        details: {
            overview:
                "Built with React, Three.js, and TypeScript. The Earth rotates at 1× speed against actual UTC, with a switchable sidereal mode and adjustable playback up to 10×. The Moon orbits with tidal locking on a ~27.3-day period. Clouds shift with simulated wind, night-side city lights are visible, and the Sun runs a procedural shader.",
            features: [
                "Earth rotates in sync with UTC at 1× speed.",
                "Solar day (86,400s) and sidereal day (86,164s) modes.",
                "Moon orbits with tidal locking on a ~27.3-day period.",
                "Visible Sun with procedural shader effects.",
                "Speed selectable at 1×, 3×, 5×, or 10×.",
                "Cloud layer with simulated wind.",
                "Accurate 23.4° axial tilt.",
                "Orbit, zoom, and explore with mouse or touch.",
                "City lights visible on the night side.",
                "Diffuse, normal, specular, cloud, and emission texture maps.",
            ],
            technologies: ["React", "Three.js", "TypeScript"],
            githubUrl: "",
            liveUrl: "https://real-time-earth.vercel.app/",
        },
    },
    {
        id: "kampujobs",
        title: "KampuJobs",
        category: "Job Platform",
        description:
            "Curated job directory built with Next.js. Filter by company, specialty, employment type, and salary.",
        images: [
            require("@public/screenshot/kampu-jobs-screenshot.png").default,
        ],
        details: {
            overview:
                "Job search and listing platform. Shareable URLs sync with search params and tags. Bookmark roles, track applications, and see what's trending. Auth handled by WorkOS AuthKit; public browsing works without login.",
            features: [
                "Search by title, keywords, and location.",
                "Shareable URLs that sync search params and tags.",
                "Detailed listing pages with full descriptions and qualifications.",
                "Bookmark jobs to save for later.",
                "Track jobs you've applied to and their status.",
                "Tracks job views, applications, and other interactions.",
                "Popular tags for trending categories.",
                "Filter by company, specialty, employment type, and salary range.",
                "Employers can post and manage listings.",
                "Auth via WorkOS AuthKit.",
                "Public browsing without login.",
                "Responsive across devices.",
                "Built with Radix UI and Tailwind CSS.",
                "Runs on Next.js 16 and React 19.",
            ],
            technologies: [
                "Next.js 16",
                "React 19",
                "Radix UI",
                "Tailwind CSS",
                "WorkOS AuthKit",
            ],
            githubUrl: "",
            liveUrl: "https://kampu-jobs.vercel.app/",
        },
    },
    {
        id: "cv-maker",
        title: "Resume Builder",
        category: "Productivity Tool",
        description:
            "Build a CV through a form interface. Pick from multiple templates and export as PDF.",
        images: [require("@public/screenshot/cv-maker.png").default],
        details: {
            overview:
                "Real-time preview as you edit. Form-based input handles standard CV sections, and templates control layout. PDF export is high-resolution.",
            features: [
                "Form-based CV builder.",
                "Several customizable templates.",
                "PDF export.",
                "Real-time preview as you edit.",
                "Layout and formatting options.",
                "Responsive layout.",
            ],
            technologies: [
                "Next.js",
                "TypeScript",
                "Tailwind CSS",
                "PDF Generation",
                "React Hook Form",
            ],
            githubUrl: "",
            liveUrl: "https://cv-maker-by-mantha.vercel.app/",
        },
    },
    {
        id: "curated-products-showcase",
        title: "Curated Products",
        category: "E-commerce",
        description:
            "Browse curated products across Tech, Workspace, Home, Carry, Books, and Lifestyle.",
        images: [
            require("@public/screenshot/curated-products-showcase.png").default,
        ],
        details: {
            overview:
                "An e-commerce-style showcase for well-designed objects. Inspired by product editorial sites. Built with React, TypeScript, and Vite.",
            features: [
                "Browse a curated collection of products.",
                "Filter by All, New, Picks, Tech, Workspace, Home, Carry, Books, or Lifestyle.",
                "Staff picks highlighted.",
                "Newsletter signup in the hero.",
                "Responsive across mobile, tablet, and desktop.",
                "Minimalist design with hover and transition details.",
                "Navigation with built-in search.",
            ],
            technologies: ["React", "TypeScript", "Vite", "Tailwind CSS"],
            githubUrl: "",
            liveUrl: "https://curated-products-showcase.vercel.app/",
        },
    },
    {
        id: "emotional-vent-space",
        title: "Emotional Vent Space",
        category: "Social Platform",
        description: "Anonymous forum for sharing thoughts and feelings.",
        images: [
            require("@public/screenshot/emotional-vent-space.png").default,
        ],
        details: {
            overview:
                "A small, focused web app. Anonymous submissions display in a live feed. The product is built around safety, accessibility, and not getting in the way.",
            features: [
                "Anonymous submissions with a live feed.",
                "Accessibility-focused design.",
                "Safety considerations baked into the flow.",
            ],
            technologies: ["Next.js", "TypeScript", "Tailwind CSS"],
            githubUrl: "",
            liveUrl: "https://safe-venting-space.vercel.app/",
        },
    },
    {
        id: "slideup",
        title: "SlideUp (In Progress)",
        category: "Interactive Tool",
        description:
            "Real-time audience engagement for presenters. Audience joins via QR code to submit questions, vote in polls, and share feedback.",
        images: [require("@public/screenshot/slide-up.png").default],
        details: {
            overview:
                "For teachers, trainers, and anyone running a session in front of a group. Display slides with an auto-generated QR; audience members open it on their phones to send questions and vote. Presenters can set submission deadlines and highlight top-voted questions.",
            features: [
                "Create and manage live sessions with custom themes.",
                "Display slides with an auto-generated QR code.",
                "View audience interactions live.",
                "Set submission deadlines.",
                "Moderate and highlight top-voted questions.",
                "Audience can submit questions, vote in polls, and share feedback.",
            ],
            technologies: [
                "Next.js",
                "TypeScript",
                "Real-time WebSockets",
                "QR Code Generation",
                "Tailwind CSS",
            ],
            githubUrl: "",
            liveUrl: "https://slide-up.vercel.app/",
        },
    },
    {
        id: "quizlab",
        title: "QuizLab",
        category: "Education",
        description:
            "Quiz platform for creating, sharing, and analyzing quizzes.",
        images: [require("@public/screenshot/quizlabz.png").default],
        details: {
            overview:
                "Built for educators and trainers. Drag-and-drop quiz builder, real-time collaboration, and analytics for tracking learner progress.",
            features: [
                "Drag-and-drop quiz builder.",
                "Real-time collaboration.",
                "Analytics and reporting.",
                "Multiple question types.",
                "Student progress tracking.",
            ],
            technologies: [
                "React",
                "Node.js",
                "MongoDB",
                "Socket.io",
                "Chart.js",
            ],
            githubUrl: "https://github.com/yourusername/quizlab",
            liveUrl: "https://www.quizlabz.com/?tab=trending",
        },
    },
    {
        id: "timespot",
        title: "Time Spot",
        category: "Utility",
        description:
            "Big time display with selectable presets. Presets stored in Notion.",
        images: [require("@public/screenshot/timespot.png").default],
        details: {
            overview:
                "A focused single-screen tool. Pick a time to display, switch formats, and toggle full screen. Presets sync via the Notion API.",
            features: [
                "Large time display.",
                "Customizable time formats.",
                "Notion API integration.",
                "Preset management.",
                "Full-screen mode.",
            ],
            technologies: [
                "React",
                "Notion API",
                "CSS Grid",
                "Local Storage",
                "PWA",
            ],
            githubUrl: "https://github.com/yourusername/timespot",
            liveUrl: "https://time-spot.vercel.app",
        },
    },
    {
        id: "big-schedule-agenda",
        title: "Big Schedule Agenda",
        category: "Productivity Tool",
        description:
            "Lightweight real-time planner. Drag-and-drop events, color-coded tasks, instant sharing, and cross-device sync.",
        images: [require("@public/screenshot/big-schedule-agenda.png").default],
        details: {
            overview:
                "A scheduling and planning tool for teams and individuals. Real-time updates over Firebase keep everyone aligned across devices.",
            features: [
                "Drag-and-drop event creation.",
                "Color-coded task organization.",
                "Real-time collaboration.",
                "Cross-device sync.",
                "Calendar integration.",
            ],
            technologies: ["Vue.js", "Firebase", "Vuex", "Vuetify", "PWA"],
            githubUrl: "https://github.com/yourusername/big-schedule-agenda",
            liveUrl: "https://big-schedule-eight.vercel.app/",
        },
    },
    {
        id: "youtube-transcript",
        title: "YouTube Transcript",
        category: "Utility",
        description:
            "Extract, search, and download transcripts from any YouTube video.",
        images: [require("@public/screenshot/youtube-transcript.png").default],
        details: {
            overview:
                "A utility for content creators and researchers. Automatic transcript extraction with in-transcript search and timestamp navigation. Supports bulk processing across multiple videos.",
            features: [
                "Automatic transcript extraction.",
                "Search within transcripts.",
                "Download in multiple formats.",
                "Timestamp navigation.",
                "Bulk processing across multiple videos.",
            ],
            technologies: [
                "Python",
                "FastAPI",
                "YouTube API",
                "React",
                "PostgreSQL",
            ],
            githubUrl: "https://github.com/yourusername/youtube-transcript",
            liveUrl: "https://youtube-transcript-five.vercel.app/",
        },
    },
    {
        id: "gate-play-streaming",
        title: "GatePlay Streaming",
        category: "Streaming Platform",
        description:
            "Landing page for a curated streaming service. Pitched around handpicked weekly selections instead of algorithm-driven feeds.",
        images: [
            require("@public/screenshot/gate-play-streaming.jpeg").default,
        ],
        details: {
            overview:
                "Dark theme tuned to make posters and cover art read well. Includes scroll-triggered fade and slide animations, hover-scaled carousels, and clear sections for pricing and subscription tiers.",
            features: [
                "Dark UI tuned for poster and content art.",
                "Fade and slide animations as sections enter the viewport.",
                "Horizontal carousels with hover-scaled tiles.",
                "Satoshi typography from Fontshare.",
                "Responsive from mobile to desktop.",
                "Pricing and value-prop sections with subscription tiers.",
            ],
            technologies: [
                "Next.js 15",
                "React 19",
                "Tailwind CSS v4",
                "Motion (Framer Motion)",
                "Lucide React",
                "Fontshare (Satoshi)",
            ],
            githubUrl: "https://github.com/phalla-doll/gate-play-streaming",
            liveUrl: "https://gate-play-streaming.vercel.app",
        },
    },
    {
        id: "finbiz",
        title: "Finbiz",
        category: "Finance SaaS",
        description: "Dark-themed landing page for a finance SaaS.",
        images: [require("@public/screenshot/finbiz-screenshot.png").default],
        details: {
            overview: "Grid-based dark layout. Single-page marketing site.",
            features: [
                "Dark color scheme.",
                "Responsive across device sizes.",
                "Minimal grid-based layout.",
            ],
            technologies: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
            githubUrl: "https://github.com/phalla-doll/finbiz",
            liveUrl: "https://finbiz-mauve.vercel.app",
        },
    },
    {
        id: "visual-evo",
        title: "Visual Evo",
        category: "AI Tool",
        description: "Hero section design for an AI portrait tool.",
        images: [
            require("@public/screenshot/visual-evo-screenshot.jpeg").default,
        ],
        details: {
            overview:
                "A landing-page hero for an AI portrait product. Minimal layout.",
            features: [
                "Full-bleed landing hero.",
                "Built around AI portrait workflows.",
                "Minimal aesthetic.",
            ],
            technologies: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
            githubUrl: "https://github.com/phalla-doll/visual-evo",
            liveUrl: "https://visual-evo.vercel.app",
        },
    },
    {
        id: "depth-thumb-editor",
        title: "DepthThumb Editor",
        category: "Design Tool",
        description:
            "Thumbnail editor with 3D depth effects and visual styling tools.",
        images: [require("@public/screenshot/depth-thumb-editor.jpeg").default],
        details: {
            overview:
                "1280×720 editing canvas with layer management, 150+ fonts pulled from Fontshare, and templates for gaming, vlog, tech, and podcast thumbnails. Export to PNG, JPEG, or WebP.",
            features: [
                "1280×720 canvas with zoom controls.",
                "Layer management with Assets and Layers tabs.",
                "Toggleable grid overlays and safe zones.",
                "Real-time thumbnail preview.",
                "150+ fonts via the Fontshare API.",
                "Font family, weight (100 to 900), and size controls.",
                "Fill and stroke color controls.",
                "Extrusion (0 to 100px), shadow distance (0 to 50px), Z-rotation (-45° to +45°).",
                "Neon glow with soft and hard modes, smart blur (0 to 20px), and background blur.",
                "Templates for gaming, vlog, tech, and podcast thumbnails.",
                "Upload custom images and assets.",
                "Export as PNG, JPEG, or WebP.",
            ],
            technologies: [
                "Next.js 15.4.9",
                "React 19.2.1",
                "TypeScript 5.9",
                "Tailwind CSS 4.1",
                "Lucide React 0.553.0",
                "Motion 12.23.24",
                "Google Fonts (Space Grotesk)",
                "Fontshare API",
                "Google GenAI SDK 1.17.0",
            ],
            githubUrl: "https://github.com/phalla-doll/depth-thumb-editor",
            liveUrl: "https://depth-thumb-editor.vercel.app",
        },
    },
    {
        id: "luxury-wedding-invitation",
        title: "Luxury Wedding Invitation",
        category: "Event Website",
        description:
            "Scroll-driven wedding invitation site. Built for Jordan and Sophia's wedding on June 21, 2026.",
        images: [require("@public/screenshot/wedding-invitation.jpeg").default],
        details: {
            overview:
                "Full-screen hero with parallax. Guest names personalize via a ?guest=Name URL parameter. Includes narrative sections (Our Story, Proposal), event details, a photo gallery with grayscale-to-color hover, and an interactive map via MapLibre GL. Lenis handles the scroll.",
            features: [
                "Full-screen hero with animated text and a parallax background.",
                "Personalized guest names via ?guest=Name URL parameter.",
                "Narrative sections with scroll-triggered animations.",
                "Event details: date, time, venue, dress code.",
                "Horizontal photo gallery with grayscale-to-color hover.",
                "Interactive venue map via MapLibre GL.",
                "Lenis-powered smooth scrolling.",
                "Confetti effects at key moments.",
                "Mobile-first, responsive across devices.",
            ],
            technologies: [
                "Next.js 15 (App Router)",
                "React 19",
                "TypeScript",
                "Tailwind CSS 4",
                "GSAP 3 + ScrollTrigger",
                "MapLibre GL + react-map-gl",
                "Canvas Confetti",
                "Lucide React",
                "React Icons",
                "Google Fonts (Inter, Playfair Display, Great Vimes)",
            ],
            githubUrl:
                "https://github.com/phalla-doll/luxury-wedding-invitation",
            liveUrl: "https://luxury-wedding-invitation-lime.vercel.app",
        },
    },
    {
        id: "evolu-ebike",
        title: "Evolu Ebike",
        category: "AI Experiment",
        description: "AI experiment around ebike visualization.",
        images: [require("@public/screenshot/evolu-ebike.jpeg").default],
        details: {
            overview:
                "Experimental proof-of-concept exploring AI-driven product visualizations.",
            features: ["Experimental AI integration.", "Minimal interface."],
            technologies: ["React", "TypeScript", "Vite", "Tailwind CSS"],
            githubUrl: "https://github.com/phalla-doll/evolu-ebike",
            liveUrl: "https://evolu-ebike.vercel.app",
        },
    },
    {
        id: "nexbot-ai",
        title: "Nexbot AI",
        category: "AI Agent Interface",
        description: "AI agent interface with 3D interactive elements.",
        images: [require("@public/screenshot/next-bot-ai.jpeg").default],
        details: {
            overview:
                "Experimental proof-of-concept for an AI chat interface that leans on 3D visual elements.",
            features: [
                "AI chat interface.",
                "3D visual components.",
                "Futuristic aesthetic.",
            ],
            technologies: [
                "Next.js",
                "React",
                "TypeScript",
                "Tailwind CSS",
                "Motion",
            ],
            githubUrl: "https://github.com/phalla-doll/nexbot-ai",
            liveUrl: "https://nexbot-ai.vercel.app",
        },
    },
    {
        id: "pitch-deck",
        title: "Pitch Deck",
        category: "Presentation Tool",
        description:
            "Pitch deck landing page with a technical, editorial aesthetic.",
        images: [require("@public/screenshot/pitch-deck.png").default],
        details: {
            overview: "Single-page showcase for presentation materials.",
            features: [
                "Presentation showcase.",
                "Technical aesthetic.",
                "Editorial visual language.",
            ],
            technologies: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
            githubUrl: "https://github.com/phalla-doll/pitch-deck",
            liveUrl: "https://pitch-deck-sooty-eight.vercel.app",
        },
    },
    {
        id: "fetz-dental-clinic",
        title: "Fetz Dental Clinic",
        category: "Healthcare Website",
        description:
            "React site for a dental clinic. Bento-grid layouts and scroll animations.",
        images: [require("@public/screenshot/fetz-dental.jpeg").default],
        details: {
            overview:
                "Color palette uses fresh lime and olive. Bento-grid hero, horizontal-scrolling Services and Team sections with snap physics, and modals for service details, team profiles, and booking. Includes a forum with thread viewing, filtering, search, and a mock login check on creation.",
            features: [
                "Responsive from mobile to desktop.",
                "Bento-grid hero section.",
                "Elements reveal on scroll via a custom ScrollReveal component.",
                "Horizontal Services and Team lists with snap physics.",
                "Service cards open into treatment detail modals.",
                "Team profile modals with bio and stats.",
                "Multi-step booking modal with validation and success states.",
                "Forum with thread viewing, category filters, keyword search, and a mock login check on creation.",
                "Meta tags for social sharing and Google Analytics event tracking.",
            ],
            technologies: [
                "React 19 (via ESM)",
                "TypeScript",
                "Tailwind CSS (via CDN)",
                "Lucide React",
                "Google Fonts (DM Sans & Inter)",
                "Google Analytics (gtag)",
            ],
            githubUrl: "https://github.com/phalla-doll/fetz-dental-clinic",
            liveUrl: "https://fetz-clinic.vercel.app",
        },
    },
    {
        id: "horizon-estate",
        title: "Horizon Estate",
        category: "Real Estate",
        description:
            "Real estate landing page built to match a provided mockup.",
        images: [require("@public/screenshot/horizon-estate.jpeg").default],
        details: {
            overview:
                "Property listings, search by criteria, and detail pages.",
            features: [
                "Real estate visual design from the provided mockup.",
                "Property listings.",
                "Search by criteria.",
                "Clean layout.",
                "Responsive across devices.",
            ],
            technologies: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
            githubUrl: "https://github.com/phalla-doll/horizon-estate",
            liveUrl: "https://horizon-estate-gamma.vercel.app",
        },
    },
]
